import { Injectable } from '@angular/core';
import moment from 'moment';

const WEEKEND = [moment().day("Saturday").weekday(), moment().day("Sunday").weekday()]

export const addBusinessDays = (date, daysToAdd) => {
  let daysAdded = 0;
  let momentDate = moment(new Date(date));

  while (daysAdded < daysToAdd) {
    momentDate = momentDate.add(1, 'days');
    if (!WEEKEND.includes(momentDate.weekday())) {
      daysAdded++;
    }
  }

  return momentDate;
};

@Injectable({
  providedIn: 'root'
})
export class UtilsService {


  constructor() { }

  public copyToClipboard(val: string): void {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  public splitToColumns(input: Array<any>, columns: number): Array<any> {
    return [...Array(columns).keys()].map(c => input.filter((_, i) => i % columns === c));
  }
}
